import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { InputMultiSelectModule } from 'src/components/input/input-multi-select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DirectivesModule } from '../../../../components/directives.module';
import { EditComponent } from './edit.component';
import { InputTextModule } from '../../../../components/input/input-text';
import { InputSelectModule } from '../../../../components/input/input-select';
import { InputCheckboxModule } from '../../../../components/input/input-checkbox';
import { RosterModule } from '../../../../components/roster';
import { WorkTimeModule } from '../../../../components/work-time';

const ROUTES: Routes = [
  { path: '', component: EditComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    DragDropModule,
    InputTextModule,
    InputCheckboxModule,
    InputSelectModule,
    InputMultiSelectModule,
    RosterModule,
    WorkTimeModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [EditComponent],
  exports: [EditComponent],
})
export class EditModule {
}
